<div class="modal-header d-flex align-items-center justify-content-between">
  <h4 class="modal-title">Select Destination Folder</h4>
  <button type="button" class="btn-close" aria-label="Close" (click)="dismiss()"></button>
</div>

<div class="modal-body">
  <div>
    <!-- Breadcrumbs -->
    <nav aria-label="breadcrumb" class="flex-grow-1 mb-3">
      <ol class="breadcrumb mb-0 align-items-center bg-light px-2 py-1 rounded-pill">
        <li class="breadcrumb-item">
          <a href="javascript:void(0)" (click)="navigateToBreadcrumb(-1)" class="text-decoration-none">
            <i class="bi bi-house-door-fill"></i> Root
          </a>
        </li>
        @for (folder of currentPath; track folder; let i = $index) {
          <li class="breadcrumb-item">
            @if (i < currentPath.length - 1) {
              <a href="javascript:void(0)" (click)="navigateToBreadcrumb(i)" class="text-decoration-none">{{ folder.name }}</a>
            }
            @if (i === currentPath.length - 1) {
              <span class="text-secondary">{{ folder.name }}</span>
            }
          </li>
        }
      </ol>
    </nav>

    <!-- Folder List -->
    @if (displayedFolders.length > 0) {
      <div class="list-group list-group-flush" style="max-height: 300px; overflow-y: auto;">
        @for (folder of displayedFolders; track folder) {
          <a
            href="javascript:void(0)"
            class="list-group-item list-group-item-action d-flex justify-content-between align-items-center"
            (click)="navigateToFolder(folder)">
            <div>
              <i class="bi bi-folder-fill me-2 op-text-folder"></i> {{ folder.name }}
              @if (folder.defaultFolder) {
                <span class="badge bg-info ms-2">Default</span>
              }
            </div>
            <i class="bi bi-chevron-right"></i>
          </a>
        }
      </div>
    }

    <!-- Empty State: No sub-folders in current view -->
    @if (currentPath.length > 0 && displayedFolders.length === 0) {
      <div class="text-center text-muted p-3">
        <i class="bi bi-folder-x fs-3"></i>
        <p class="mt-2">This folder has no sub-folders.</p>
        @if (!currentSelectedFolderAsDestination) {
          <p class="mt-1"><small>You cannot select an empty folder that has no sub-folders to navigate into, but you can select this folder itself using the button below if it's a valid destination.</small></p>
        }
      </div>
    }

    <!-- Empty State: Root view is empty -->
    @if (currentPath.length === 0 && rootFolders.length === 0) {
      <div class="text-center text-muted p-3">
        <i class="bi bi-diagram-3-fill fs-3"></i>
        <p class="mt-2">No root folders found.</p>
        <p><small>Cannot select a folder if none are available.</small></p>
      </div>
    }
  </div>
</div>

<div class="modal-footer">
  <button type="button" class="btn btn-outline-secondary" (click)="dismiss()">Cancel</button>
  <button type="button"
    class="btn btn-primary"
    (click)="confirmSelection()"
    [disabled]="!currentSelectedFolderAsDestination">
    <i class="bi bi-check-circle me-1"></i> Select This Folder
  </button>
</div>